export const transitionBaseClass = "transition-all duration-300 ease-in-out";

export const navItemStateBaseClass =
  "hover:bg-grey-fog-1 focus:underline focus:bg-grey-fog-1 focus:outline-none";

export const focusStyle =
  "focus:outline focus:outline-blue-focus focus:outline-2";

export const contentContainerId = "content";

export const leftHandNavId = "left-hand-nav";

export const lhnLocalStorageVisibilityKey = "lhn-visibility";

export const myAccountLink = "/myhome/";

export const performerViewPinPath = "/:code(\\d{4}-\\d{4}-\\d{4})";
